export const teamData = [
    {
      year:"2023-24",
      lead:{
        name:"Yash Gangan",
        social:"",
        url:"./images/DSC Team/Batch23-24/Yash_Gangan.jpg"
      },
      team:[
        {
          name:"Ratnapal Shende",
          designation:"Android Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Ratnapal_Shende.jpg"
        },
        {
          name:"Anita Marvar",
          designation:"Android Co-Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Anita_Marvar.jpeg"
        },
        {
          name:"Soham Thodge",
          designation:"Cloud Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Soham_Thodge.jpg"
        },
        {
          name:"Tejaram Chaudhari",
          designation:"Cloud Co-Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Tejaram_Chaudhary.jpg"
        },
        {
          name:"Sakshi Mavalkar",
          designation:"Design And Content Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Sakshi_Mavalkar.jpeg"
        },
        {
          name:"Yadnit Kale",
          designation:"DSA Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Yadnit_Kale.jpg"
        },
        {
          name:"Shon Gaikwad",
          designation:"DSA Co-Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Shon_Gaikwad.jpeg"
        },
        {
          name:"Abhinav Shukla",
          designation:"Events Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Abhinav_Shukla.jpg"
        },
        {
          name:"Sarthak Jain",
          designation:"Events Co-Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Sarthak_Jain.jpg"
        },
        {
          name:"Omkar Mahangare",
          designation:"Web Lead",
          social:"https://www.linkedin.com/in/omkar-mahangare",
          url:"./images/DSC Team/Batch23-24/Omkar_Mahangare.jpg"
        },
        {
          name:"Nishadh Nikam",
          designation:"Web Co-Lead",
          social:"",
          url:"./images/DSC Team/Batch23-24/Nishadh_Nikam.jpeg"
        },
      ]
    },
    {
      year: "2022-23",
      lead: {
        name: "Saba Sayyed",
        social: "https://www.linkedin.com/in/saba-sayyed-568539232/",
        url: "./images/DSC Team/Saba-Sayyed.jpg"
      },
      team: [
        {
          name: "Eeshan Mishra",
          designation: "Technical Lead",
          social: "https://www.linkedin.com/in/eeshanmishra01/",
          url: "./images/DSC Team/Technical Team/Eeshan-Mishra.jpg"
        },
        {
          name: "Faizan Kalkoti",
          designation: "Android Lead",
          social: "https://www.linkedin.com/in/faizan-kalkoti-40994121a/",
          url: "./images/DSC Team/Android Team/FaizanKalkoti.jpg"
        },
        {
          name: "Girish Bansode",
          designation: "Web Lead",
          social: "https://www.linkedin.com/in/girishban/",
          url: "./images/DSC Team/Web Team/Girish-Bansode.jpg"
        },
        {
          name: "Prasanna Shinde",
          designation: "Events Lead",
          social: "https://www.linkedin.com/in/prasanna-shinde-298b74231/",
          url: "./images/DSC Team/Events and Management Team/Prasanna-Shinde.jpg"
        },
        {
          name: "Aum Battul",
          designation: "Design And Content Lead",
          social: "https://www.linkedin.com/in/aum-battul-4b42801bb/",
          url: "./images/DSC Team/Content and Design team/AumBattul.jpg"
        }
      ]
    },
    {
      year: "2022-21",
      lead: {
        name: "Zahra Dehghan",
        social: "https://www.linkedin.com/in/zahra-dehghan-8ab05b193/",
        url: "./images/DSC Team/Zahra-dsc.jpg"
      },
      team: [
        {
          name: "Vedant Bhogawade",
          designation: "Technical Lead",
          social: "https://www.linkedin.com/in/vedantbhogawade-785856193/",
          url: "./images/DSC Team/Technical Team/Vedant Bhogawade-dsc.jpg"
        },
        {
          name: "Mohammad Ali Inamdar",
          designation: "Android Lead",
          social: "https://www.linkedin.com/in/mohammedaliinamdar/",
          url: "./images/DSC Team/Android Team/Mohammed Ali-dsc.jpg"
        },
        {
          name: "Tanmay Shinde",
          designation: "Web Lead",
          social: "https://www.linkedin.com/in/tanmay-p-shinde/",
          url: "./images/DSC Team/Web Team/Tanmay Shinde.jpg"
        },
        {
          name: "Mohammad Anas",
          designation: "Events Lead",
          social: "https://www.linkedin.com/in/mohammad-anas-/",
          url: "./images/DSC Team/Events and Management Team/Mohammad Anas-dsc.jpg"
        },
        {
          name: "Raj Thakur",
          designation: "Design And Content Lead",
          social: "https://www.linkedin.com/in/raj-thakur-2b946a20b/",
          url: "./images/DSC Team/Content and Design team/Raj Thakur-dsc.jpg"
        },
        {
          name:"Sakshi Sawant",
          designation: "Management Lead",
          social: "https://www.linkedin.com/in/sakshi-shankar-sawant-3772431b3",
          url: "./images/DSC Team/Events and Management Team/sakshi sawant-dsc-test.jpg"
        },
        {
          name:"Rutuja Shinde",
          designation: "Management Co-Lead",
          social: "",
          url: "./images/DSC Team/Events and Management Team/Rutuja Shinde-dsc.jpg"
        }
      ]
    }
  ]